export default {
  fetching: false,
  campaigns: {},
  currentMasterCampaign: null,
  currentPlatforms: [],
    sendingAuditForReceipt: false,
    audits: {},
    sendingEmail: {},
    silentRejections: {},
    errors: {},
    searching: false,
    searchQuery: "",
    searchResults: null,
    filterAccordionOpen: false,
  ugcResourceType: null,
  filters: [],  
};



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/initialState.js